#import "@/apollo/fragments/ComputedDeliverable.gql"

query PaginatedDeliverables($campaignId: ID!, $libraryFilters: InputLibraryFilters!, $page: Int, $perPage: Int) {
    computeDeliverables(
        campaignId: $campaignId
        libraryFilters: $libraryFilters
        page: $page
        perPage: $perPage
        preview: true
    ) {
        deliverables {
            ...ComputedDeliverable
        }
        pagination {
            page
            perPage
            maxPage
            total
            totalCount
        }
    }
}
